import {
    TicketContent,
    TicketContentText,
    TicketSubtitle,
} from '../../common/components/ticketplus/TicketPlusLayout';
import {
    ticketNotFoundModalMessage,
    ticketNotFoundModalTitle,
} from '../../common/components/ticketplus/TicketPlusModalTexts';
import { isRunningInNativeWrapper } from '../../Native.ts';
import {
    FullWidthBottomButton,
    FullWidthBottomButtonColor,
} from '../../common/components/FullWidthBottomButton.tsx';
import { useNavigate } from 'react-router';

export function QuickCheckoutFlowTicketNotFound() {
    const navigate = useNavigate();
    return (
        <TicketContent>
            <TicketSubtitle>{ticketNotFoundModalTitle}</TicketSubtitle>
            <TicketContentText>{ticketNotFoundModalMessage}</TicketContentText>
            {isRunningInNativeWrapper() && (
                <FullWidthBottomButton
                    color={FullWidthBottomButtonColor.WHITE}
                    onClick={() => navigate('/')}
                    label={{
                        de: 'Schliessen',
                        fr: 'Fermer',
                        it: 'Chiudi',
                        en: 'Close',
                    }}
                />
            )}
        </TicketContent>
    );
}
